/* Enhances the server-rendered related products; the native product controller
 * remains responsible for variant, media, availability, price and cart state. */
(()=>{
 const pending=new WeakSet();
 const initialise=(scope=document)=>{
  for(const target of scope.querySelectorAll('[data-moi-recommendations]')){
   if(pending.has(target))continue;
   pending.add(target);
   const load=async()=>{
    try{
     const url=new URL(target.dataset.recommendationUrl,location.origin);
     url.searchParams.set('section_id',target.dataset.sectionId);
     url.searchParams.set('product_id',target.dataset.productId);
     url.searchParams.set('limit','4');url.searchParams.set('intent','related');
     const response=await fetch(url,{headers:{Accept:'text/html'}});
     if(!response.ok)return;
     const documentResult=new DOMParser().parseFromString(await response.text(),'text/html');
     const result=documentResult.querySelector('[data-moi-recommendations]');
     if(!result||result.hidden||!result.querySelector('.moi-product-card'))return;
     target.replaceChildren(...result.childNodes);target.hidden=false;
     document.dispatchEvent(new CustomEvent('moi:products:loaded',{detail:{root:target}}));
    }catch{/* The real category/brand cards rendered by Liquid stay available. */}
   };
   if('IntersectionObserver' in window && !target.hidden){
    const observer=new IntersectionObserver(entries=>{if(entries.some(entry=>entry.isIntersecting)){observer.disconnect();load();}},{rootMargin:'500px'});
    observer.observe(target);
   }else load();
  }
 };
 initialise();document.addEventListener('shopify:section:load',event=>initialise(event.target));
})();
